// import React, { useEffect, useState, useRef } from "react";
// import { observer } from "mobx-react";

// const SetKpiTargetTableBody = ({ listData = [], onDataChange }) => {
//   const [localData, setLocalData] = useState([]);
//   const isFirstLoad = useRef(true);

//   useEffect(() => {
//     if (Array.isArray(listData)) {
//       const formatted = listData.map((item) => ({
//         ...item,
//         target:
//           item.target !== null && item.target !== undefined
//             ? Number(item.target)
//             : "",
//       }));

//       // Only set localData if it's the first load
//       if (isFirstLoad.current) {
//         setLocalData(formatted);
//         isFirstLoad.current = false;
//       }
//     }
//   }, [listData]);

//   const onChangeHandler = (e, fieldId) => {
//     const { name, value } = e.target;
//     const updated = localData.map((item) =>
//       item.fieldId === fieldId ? { ...item, [name]: value } : item
//     );

//     setLocalData(updated);         // ✅ update the input value in UI
//     onDataChange(updated);         // ✅ notify the parent of the changes
//   };

//   return (
//     <tbody>
//       {localData.length > 0 ? (
//         localData.map((element, index) => (
//           <tr key={element.fieldId || index}>
//             <td>{index + 1}</td>
//             <td>{element.catName || "-"}</td>
//             <td>{element.subCatName || "-"}</td>
//             <td>{element.kpiName || "-"}</td>
//             <td>{element.fieldName}</td>
//             <td>
//               <input
//                 type="number"
//                 name="target"
//                 value={element.target}
//                 onChange={(e) => onChangeHandler(e, element.fieldId)}
//                 className="rounded form-control w-100 numberCountInput"
//               />
//             </td>
//           </tr>
//         ))
//       ) : (
//         <tr>
//           <td colSpan={6}>
//             <div className="text-center">No records found</div>
//           </td>
//         </tr>
//       )}
//     </tbody>
//   );
// };

// export default observer(SetKpiTargetTableBody);
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

const SetKpiTargetTableBody = ({ listData = [], onDataChange }) => {
  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    if (Array.isArray(listData)) {
      const formatted = listData.map((item) => ({
        ...item,
        target:
          item.target !== null && item.target !== undefined
            ? String(item.target)
            : "",
      }));

      // Compare with existing localData to detect new list
      const incomingIds = formatted.map((i) => i.fieldId).sort().join(",");
      const currentIds = localData.map((i) => i.fieldId).sort().join(",");

      if (incomingIds !== currentIds) {
        setLocalData(formatted);
        onDataChange(formatted); // Optional: push to parent initially
      }
    }
  }, [listData]);

  const onChangeHandler = (e, fieldId) => {
    const { name, value } = e.target;

    const updated = localData.map((item) =>
      item.fieldId === fieldId ? { ...item, [name]: value } : item
    );

    setLocalData(updated);
    onDataChange(updated); // Push changes to parent
  };

  return (
    <tbody>
      {localData.length > 0 ? (
        localData.map((element, index) => (
          <tr key={element.fieldId || index}>
            <td>{index + 1}</td>
            <td>{element.catName || "-"}</td>
            <td>{element.subCatName || "-"}</td>
            <td>{element.kpiName || "-"}</td>
            <td>{element.fieldName}</td>
            <td>
              <input
                type="number"
                name="target"
                value={element.target}
                onChange={(e) => onChangeHandler(e, element.fieldId)}
                className="rounded form-control w-100 numberCountInput"
              />
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={6}>
            <div className="text-center">No records found</div>
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default observer(SetKpiTargetTableBody);
